import styled from 'styled-components'
import {colors} from "../../utils/colors";
import React from "react";
import {Profil} from "../../models/Profil";

const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 15px;
  background-color: ${colors.backgroundLight};
  border-radius: 30px;
  flex-basis: 300px;
  transition: 200ms;

  &:hover {
    cursor: pointer;
    box-shadow: 2px 2px 10px #e2e3e9;
  }
`

const CardLabel = styled.span
    `
      color: #5843e4;
      font-size: 22px;
      font-weight: bold;
    `

const CardImage = styled.img`
  height: 80px;
  width: 80px;
  border-radius: 50%;
`

export function Card(props: { profil: Profil }) {
    const {profil} = props
    return (
        <CardWrapper>
            <CardLabel>{profil.name}</CardLabel>
            <CardImage src={profil.picture} alt="freelance"/>
            <span>{profil.job}</span>
        </CardWrapper>
    )
}
